import React, { useState, useEffect } from 'react';
import './CustomerApproved.css';
// import '../AccidentVehicle/AccidentVehicle.css';
import '../../AccidentVehicle/AccidentVehicle.css';
import axios from '../../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { ClipLoader } from 'react-spinners';
import { Alert } from '@mui/material';
import ActivationModel from '../../../../Component/CompanyAdmin/ActivationModel/ActivationModel';
import { Helmet } from 'react-helmet-async';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DataTable from "react-data-table-component";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Admin from '../../AdminHome/SideBar/Admin';
import { Search, Download } from "lucide-react";
import { exportToExcel } from '../../../../Services/exportToExcel';


const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const parseDate = (dateString) => {
  const [day, month, year] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day); // Months are 0-indexed in JavaScript
};


const CustomerApproved = () => {

  const [modalOpenHere, setModalOpenHere] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalSeverity, setModalSeverity] = useState('');
  const getDepartment = localStorage.getItem("department");
  console.log("getDepartment", getDepartment)
  const userRole = localStorage.getItem("userRole") || getDepartment || "";
  const canExport = String(userRole).toLowerCase() === "management";


  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [isGenerated, setIsGenerated] = useState(false);
  const [generatedExcel, setGeneratedExcel] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info', timestamp: null });
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [deleteData, setDeleteData] = useState(null);


  const [showCustomerMasterEdit, setShowCustomerMasterEdit] = useState(false)
  const [showCustomerPerformance, setShowCustomerPerformance] = useState(false)
  const [showCustomerTable, setShowCustomerTable] = useState(true)


  const [selectedId, setSelectedId] = useState(null);

  const [marginLeft, setMarginLeft] = useState('30px');
  const [paddingLeft, setPaddingLeft] = useState('30px');

  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowsSelected = (state) => {
    setSelectedRows(state.selectedRows);
  }

  const conditionalRowStyles = [
    {
      when: (row) => selectedRows.some(selected => selected.CustomerCode === row.CustomerCode),
      style: {
        backgroundColor: '#bdb6b6',
      },
    }
  ];

  useEffect(() => {
    if (!showCustomerMasterEdit) getData();
    if (token === "" || userId === "") {
      navigate("/");
    }
  }, [token, userId, navigate, showCustomerMasterEdit]);

  useEffect(() => {
    if (alertInfo.show) {
      const timer = setTimeout(() => {
        setAlertInfo({ ...alertInfo, show: false });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [alertInfo]);

  const tableCustomStyles = {
    headRow: {
      style: {
        color: '#ffff',
        backgroundColor: 'rgb(169 187 169)',
        fontWeight: "bold",
        fontSize: '13px'
      },
    },
    pagination: {
      style: {
        button: {
          background: 'none',
          boxShadow: "none"
        },
      },
    },
    striped: {
      style: {
        default: 'red'
      }
    },
    rows: {
      style: {
        backgroundColor: '#f2f2f2',
      }
    }
  }



  const deleteCustomer = async (id) => {
    const response = await axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/deleteCustomer/${userId}/${id}`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    getData();
    setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
  };

  const generateFile = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/dBToExcel/${userId}/customer`, { headers: { Authorization: `Bearer ${token}` }});
      setGeneratedExcel(response.data.data);
      setIsLoading(false);
      setIsGenerated(true);
    } catch (error) {
      setIsLoading(false);
      console.error(error.message);
    }
  };

  const handleConfirm = (vendorCode, isActive) => {
    deactive(vendorCode, isActive);
    setModalOpen(false);
  };

  const handleConfirmDelete = async (CustomerCode) => {
    await deleteCustomer(CustomerCode);
    setModalOpen(false);
  }



  const handleCancel = () => {
    setModalOpen(false);
  };

  const openModal = (item) => {
    setModalData(item);
    setModalOpen(true);
  };

  const openDeleteModal = (item) => {
    setDeleteData(item);
    setModalOpen(true);
  }

  const [sortDate, setSortDate] = useState("asc");
  const sortDateFunc = () => {
    setSortDate(sortDate === "asc" ? "desc" : "asc");
    const sortedItems = [...data].sort((a, b) => {
      const dateA = new Date(a.systemDate).getTime();
      const dateB = new Date(b.systemDate).getTime();
      return sortDate === "asc" ? dateA - dateB : dateB - dateA;
    });
    setData(sortedItems)
  }

  const deactive = async (id, isActivate) => {
    try {
      const response = await axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/changeActivationForCustomer/${userId}/${id}/${isActivate}`,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      getData();
      setTimeout(() => {
        setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
      }, 2000)
    } catch (error) {
      console.error("Error during form submission:", error);
      const errorMessage = error.response?.data?.message || 'An error occurred';
      setModalSeverity('error');
      if (errorMessage === "jwt expired") {
        setModalMessage("Your session has expired. Redirecting to login...");
        setModalOpenHere(true);
      } else {
        setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
      }
    }

  };

  const view = (id) => {
    setSelectedId(id);
    setShowCustomerTable(false)
    setShowCustomerMasterEdit(true)
    setShowCustomerPerformance(false)
    navigate('/customer-form-edit', {state:{id:id}})
  };

  const viewPerformance = (id) => {
    setSelectedId(id);
    setShowCustomerTable(false)
    setShowCustomerMasterEdit(false);
    setShowCustomerPerformance(true);
    console.log('id`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${state.customerId}`',id)
    navigate('/customer-form-activity', {state:{customerId:id}})

  }
  const handleUpdate = () => {
    setShowCustomerTable(true)
    setShowCustomerMasterEdit(false); // Hide VendorMasterEdit
    setShowCustomerPerformance(false);
  };

  const getData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getCustomer/${userId}`, { headers: { Authorization: `Bearer ${token}` }});
    const fetchedData = response.data.data;

    const formattedData = fetchedData.map(item => ({
      ...item,
      systemDate: formatDate(item.systemDate),
    }));
    setData(formattedData);
    setCurrentItems(formattedData);
  };

  const [currentItems, setCurrentItems] = useState(data);
  const columns = [
    {
      name: "CustomerID",
      selector: row => row.id, // Raw data for sorting
      cell: row => <span>{String(row.id).padStart(4, '0')}</span>, // Display formatted value
      sortable: true,
      sortFunction: (rowA, rowB) => rowA.id - rowB.id // Custom sort function
    },
    {
      name: "Date",
      selector: (row) => row.systemDate,
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const dateA = parseDate(rowA.systemDate);
        const dateB = parseDate(rowB.systemDate);
        return dateA - dateB; // Ascending order
      },
    },
    {
      name: "Customer Name", selector: (row) => row.CustomerName, sortable: true, width: "150px",
      cell: (row) => (
        <span style={{ color: 'brown' }}>{row.CustomerName.charAt(0).toUpperCase() + row.CustomerName.slice(1)}</span>
      )
    },
    {
      name: "Email Of Customer", selector: (row) => row.email, sortable: true, width: "200px",
      cell: (row) => (
        <a href={`mailto:${row.email}`} style={{ color: "blue", textDecoration: "none" }}>
          {row.email}
        </a>
      ),
    },
    {
      name: "Types Of Customer", selector: (row) => row.CustomerType, sortable: true,
      cell: (row) => (
        <span style={{ color: 'black', padding: '5px', borderRadius: '4px', border:"2px solid grey" }}>
          {row.CustomerType ? row.CustomerType.charAt(0).toUpperCase() + row.CustomerType.slice(1).toLowerCase() : ""}
        </span>
      ),
    },
    {
      name: "Added By",
      selector: (row) => row.addedBy || '',
      sortable: true,
      cell: (row) => {
        const addedBy = row.addedBy ? String(row.addedBy) : "";
        return (
          <span style={{ color: "green" }}>
            {addedBy.charAt(0).toUpperCase() + addedBy.slice(1).toLowerCase()}
          </span>
        );
      },
    },
    {
      name: "Modified By",
      selector: (row) => row.EditedBy || '',
      sortable: true,
      cell: (row) => {
        const EditedBy = row.EditedBy ? String(row.EditedBy) : "";
        return (
          <span style={{ color: "green" }}>
            {EditedBy.charAt(0).toUpperCase() + EditedBy.slice(1).toLowerCase()}
          </span>
        );
      },
    },

    { name: "District", selector: (row) => row.district, sortable: true },
    {
      name: "Actions",
      cell: (row) => (
        <button
          onClick={() => view(row.CustomerCode)}
          className='view-button'
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Activity",
      cell: (row) => (
        <button
          onClick={() => viewPerformance(row.CustomerCode)}
          className='view-button'
          style={{ background: '#e6e679' }}
        >
          Activity
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Activate / Deactivate",
      cell: (row) => (
        <button
          onClick={() => openModal(row)}
          className='view-button'
          style={{ background: 'rgb(190 98 98)', color: "white" }}
        >
          {row.isActive === "true" ? "Deactivate" : "Activate"}
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
   
  ];

  if(getDepartment !== "Administration"){
   columns.push ({
      name: "Delete Customer",
      cell: (row) => (
        <span
          onClick={() => openDeleteModal(row)}
          style={{ cursor: 'pointer' }}
        >
          <DeleteOutlineIcon />
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    });
  }

  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
    setSearchValue(value);

    const newRows = data.filter((row) => {
      const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
      const searchLower = value;

      const idValue = formattedId.includes(searchLower);
      const dateValue = (formatDate(row.systemDate) ?? '').toLowerCase().includes(searchLower)
      const customerNameValue = (row.CustomerName ?? '').toLowerCase().includes(searchLower);
      const emailValue = (row.email ?? '').toLowerCase().includes(searchLower);
      const CustomerTypeValue = (row.CustomerType ?? '').toLowerCase().includes(searchLower);
      const editedByValue = (row.EditedBy ?? '').toLowerCase().includes(searchLower);
      const districtValue = (row.district ?? '').toLowerCase().includes(searchLower);

      return idValue || dateValue || customerNameValue || emailValue || CustomerTypeValue || editedByValue || districtValue;
    });

    setCurrentItems(newRows);
  };

  const handleLoginAgain = () => {
    window.location.href = '/';
  };

  //  const [searchValue, setSearchValue] = useState('');

  const [filterType, setFilterType] = useState('completed');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleSubmit = async () => {
    console.log('handleSubmit calling: ')
    setIsLoading(true);
    setIsGenerated(false);

    console.log({

      filter: filterType,
      from: fromDate,
      to: toDate
    })

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/getWholeDetailsForAdmin`, {

        filter: filterType,
        from: fromDate,
        to: toDate
      });
      const fetchedData = response.data.data;
      console.log('==============')
      console.log(fetchedData)

      const formattedData = fetchedData.map(item => ({
        ...item,
        systemDate: item.systemDate ? formatDate(item.systemDate) : "",

      }));

      // console.log(formattedData)
      // setData(formattedData);
      setCurrentItems(formattedData);

    } catch (error) {
      console.log(error)
    }


    return
    // 
    try {

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/generate-excel`, {
        search: searchValue,
        filter: filterType,
        from: fromDate,
        to: toDate
      });

      if (response.data && response.data.fileUrl) {
        setGeneratedExcel(response.data.fileUrl);
        setIsGenerated(true);
      } else {
        alert('Excel file generation failed.');
      }
    } catch (error) {
      console.error('Error generating Excel:', error);
      alert('Something went wrong while generating the Excel file.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = () => {
    // Export only selected rows if any, otherwise export all current items
    const exportData = selectedRows.length > 0 ? selectedRows : currentItems;
    // console.log(currentItems)
    exportToExcel(exportData, "Report");
  };


  return (
    <div style={{marginTop: "-20px"}}>
      <Admin/>
      {showCustomerTable && (<div className="Customer-master-form" style={{ marginLeft: '10px', paddingLeft: '0px', marginRight: '10px', paddingRight: '0px' }}>
        <Helmet>
          <title>Customer Table - Claimpro</title>
          <meta name="description" content="Customer Table ClaimPro Assist." />
          <meta name="keywords" content="Vehicle Accidents, accident trucks, Customer Service, Claimpro, Claim pro Assist, Claimpro Assist, Accidental repair, Motor Insurance claim, Advocate services, Hydra Crane service, On site repair, Accident Management" />
          <link rel='canonical' href={`https://claimpro.in/CustomerApproved`} />
        </Helmet>
     
        <div style={{marginTop: "-35px"}}>
          <h3 className="bigtitle ms-5 container">Customer View / Edit</h3>

          <div className='container ms-5 mt-3' >
            <style>
              {`
                                                      .form-search {
                                                          display: flex;
                                                          flex-wrap: wrap;
                                                          gap: 10px;
                                                      }
          
                                                      @media (max-width: 768px) {
                                                          .form-search {
                                                          gap: 3px;
                                                          //   padding-right: 25px; /* ✅ Add spacing on right side */
                                                          margin-right: 25px; /* ✅ Add spacing on right side */
                                                          //   padding-left: -5px;  /* (Optional) to center more nicely */
                                                          }
          
                                                          .form-search > div {
                                                          flex: 1 1 100% !important;
                                                          min-width: 100% !important;
                                                          }
                                                      }
                                          `}
            </style>

            {/* below hidden div is unused, can be removed */}
            <div hidden className="form-search">
              {/* Search */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  Search by
                  <input
                    type="search"
                    className="form-control-sm border ps-3"
                    placeholder="Search"
                    // value={searchValue}
                    onChange={handleSearch}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* Filter Dropdown */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  Filter:
                  <select
                    className="form-control-sm border ps-2"
                    // value={filterType}
                    // onChange={e => setFilterType(e.target.value)}
                    style={{ width: '100%' }}
                  >
                    <option value="completed">Completed</option>
                    <option value="pre-canceled">Pre-canceled</option>
                    <option value="canceled">Canceled</option>
                  </select>
                </label>
              </div>

              {/* From Date */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  From:
                  <input
                    type="date"
                    className="form-control-sm border ps-2"
                    // value={fromDate}
                    // onChange={e => setFromDate(e.target.value)}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* To Date */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  To:
                  <input
                    type="date"
                    className="form-control-sm border ps-2"
                    // value={toDate}
                    // onChange={e => setToDate(e.target.value)}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* Generate/Download Excel Button */}
              <div style={{ flex: '1 1 200px', minWidth: '200px', marginTop: "10px" }}
              // onClick={handleSubmit}
              // onMouseEnter={() => setIsHovered(true)}
              // onMouseLeave={() => setIsHovered(false)}
              >
                <label className="label-class" style={{ width: '100%', display: 'block' }}>
                  &nbsp; {/* Placeholder to align */}

                  <a
                    // href={generatedExcel}
                    onClick={handleSubmit}
                    className="form-control download-link"
                    style={{ textAlign: 'center' }}
                  >
                    Search
                  </a>

                </label>
              </div>
            </div>

            <div >
              {/* Embedded CSS for responsiveness */}
              <style>
                {`
              .form-search {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
              }
            
              @media (max-width: 768px) {
                .form-search {
                  gap: 3px;
                //   padding-right: 25px; /* ✅ Add spacing on right side */
                  margin-right: 25px; /* ✅ Add spacing on right side */
                //   padding-left: -5px;  /* (Optional) to center more nicely */
                }
            
                .form-search > div {
                  flex: 1 1 100% !important;
                  min-width: 100% !important;
                }
              }
            `}
              </style>


              {/* <h3 className="bigtitle">Sign-up Vendor</h3> */}

              <div className="form-search flex">

                {/* Search */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Search by
                    <input
                      type="search"
                      className="form-control-sm border ps-3"
                      placeholder="Search"
                      // value={searchValue}
                      onChange={handleSearch}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Filter Dropdown */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Filter:
                    <select
                      className="form-control-sm border ps-2"
                      value={filterType}
                      onChange={e => setFilterType(e.target.value)}
                      style={{ width: '100%' }}
                    >
                      <option value="completed">Completed</option>
                      <option value="pre-cancelled">Pre-cancelled</option>
                      <option value="post-cancelled">Cancelled</option>
                    </select>
                  </label>
                </div>

                {/* From Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    From:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={fromDate}
                      onChange={e => setFromDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* To Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    To:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={toDate}
                      onChange={e => setToDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Buttons */}
                <div className='flex  gap-2 '>

                  {/* <Search
                    className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-gray-600"
                  />

                  <Download
                    className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-blue-600"
                  /> */}

                  <button onClick={handleSubmit}>
                    <Search className="w-6 h-6 text-gray-600" />
                  </button>
                  {canExport && (
                    <button onClick={handleExport}>
                      <Download className="w-6 h-6 text-gray-600" />
                    </button>
                  )}
                </div>

              </div>

            </div>

          </div>

        </div>

        {alertInfo.show && (
          <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
            {alertInfo.message}
          </Alert>
        )}

        <div className="container d-flex justify-content-center " >
          <div className="container-for-tables my-4">
            <DataTable
              columns={columns}
              data={currentItems}
              fixedHeader
              pagination
              selectableRows
              onSelectedRowsChange={handleRowsSelected}
              conditionalRowStyles={conditionalRowStyles}
              customStyles={tableCustomStyles}
            />
          </div>
        </div>

        <Dialog
          open={modalOpenHere}
          sx={{
            '& .MuiDialog-paper': {
              borderRadius: '15px',
              backgroundColor: modalSeverity === 'success' ? '#e0ffe0' : 'white',
            }
          }}
        >
          <DialogTitle
            sx={{
              color: modalSeverity === 'success' ? 'green' : 'red',
              fontSize: '1.2rem',
              fontWeight: 'bold',
            }}
          >
            {modalSeverity === 'success' ? 'Success' : 'Session Expired'}
          </DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              fontSize: '0.8rem',
              color: '#333'
            }}
          >
            <p style={{ marginBottom: '20px', textAlign: 'center' }}>{modalMessage}</p>
            <Button
              onClick={handleLoginAgain}
              variant="contained"
              sx={{
                backgroundColor: modalSeverity === 'success' ? 'green' : 'grey',
                color: 'white',
                fontSize: '0.8rem',
                '&:hover': { backgroundColor: modalSeverity === 'success' ? 'darkgreen' : 'darkgrey' }
              }}
            >
              Login Again
            </Button>
          </DialogContent>
        </Dialog>


        {modalData && (
          <ActivationModel
            isOpen={isModalOpen}
            onConfirm={() => handleConfirm(modalData.CustomerCode, modalData.isActive === "true" ? "false" : "true")}
            onCancel={handleCancel}

          />
        )}

        {deleteData && (
          <ActivationModel
            isOpen={isModalOpen}
            onConfirm={() => handleConfirmDelete(deleteData.CustomerCode)}
            onCancel={handleCancel}
          />
        )}
      </div>)}

      {/* {showCustomerMasterEdit && (
        <CustomerMasterEdit id={selectedId} onUpdate={handleUpdate} />
      )} */}

      {/* {showCustomerPerformance && (
        <CustomerPerformance customerId={selectedId}  onUpdate={handleUpdate} />
      )} */}
    </div>
  );
};

export default CustomerApproved;